import type { ToolDefinition } from "../types";
import optimizeTwitterImageTool from "./optimize-twitter-image";
import optimizeWhatsappImageTool from "./optimize-whatsapp-image";
import optimizeInstagramImageTool from "./optimize-instagram-image";
import optimizeYoutubeThumbnailImageTool from "./optimize-youtube-thumbnail-image";
import stickerMakerTool from "./sticker-maker";

export const socialMediaTools: ToolDefinition[] = [
  optimizeTwitterImageTool,
  optimizeWhatsappImageTool,
  optimizeInstagramImageTool,
  optimizeYoutubeThumbnailImageTool,
  stickerMakerTool,
];

export { default as optimizeTwitterImageTool } from "./optimize-twitter-image";
export { default as optimizeWhatsappImageTool } from "./optimize-whatsapp-image";
export { default as optimizeInstagramImageTool } from "./optimize-instagram-image";
export { default as optimizeYoutubeThumbnailImageTool } from "./optimize-youtube-thumbnail-image";
export { default as stickerMakerTool } from "./sticker-maker";
